import 'sos-common/js/utils/polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import * as Components from '../react-components';
import ReactModal from 'react-modal';

import 'sos-common/fonts/Jost/Jost-500-Medium.ttf';
import 'sos-common/fonts/Jost/Jost-500-Medium.woff';
import 'sos-common/fonts/Jost/Jost-500-Medium.woff2';
import 'sos-common/fonts/Jost/Jost-600-Semi.ttf';
import 'sos-common/fonts/Jost/Jost-600-Semi.woff';
import 'sos-common/fonts/Jost/Jost-600-Semi.woff2';
import 'sos-common/fonts/Jost/Jost-Regular.ttf';
import 'sos-common/fonts/Jost/Jost-Regular.woff';
import 'sos-common/fonts/Jost/Jost-Regular.woff2';
import 'sos-common/fonts/Jost/Jost-v4-latin-500.eot';
import 'sos-common/fonts/Jost/Jost-v4-latin-600.eot';
import 'sos-common/fonts/Jost/Jost-v4-latin-500.eot';

import 'sos-common/fonts/Futura/366AC1_0_0.eot';
import 'sos-common/fonts/Futura/366AC1_0_0.ttf';
import 'sos-common/fonts/Futura/366AC1_0_0.woff';
import 'sos-common/fonts/Futura/366AC1_0_0.woff2';
import 'sos-common/fonts/Futura/368006_0_0.eot';
import 'sos-common/fonts/Futura/368006_0_0.ttf';
import 'sos-common/fonts/Futura/368006_0_0.woff';
import 'sos-common/fonts/Futura/368006_0_0.woff2';

import 'sos-common/fonts/Flaticon/Flaticon.eot';
import 'sos-common/fonts/Flaticon/Flaticon.ttf';
import 'sos-common/fonts/Flaticon/Flaticon.woff';

global['React'] = React;
global['ReactDOM'] = ReactDOM;
global['ReactDOMServer'] = ReactDOMServer;
global['SOS'] = { Components: Components };

export { Components };

window.addEventListener('load', () => {
  ReactModal.setAppElement('main');
});
